import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CTABand from "../components/resource/CTABand";
import { RESOURCES } from "../i18n/resources";
import { container, item, inView } from "../components/service/presets";
import { ArrowRight } from "lucide-react";

export default function CaseStudies() {
  const { t, dir, lang } = useLang();
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";
  const items = RESOURCES[lang].caseStudies;

  return (
    <div>
      <PageHero tag={t.res.caseTag} title={t.res.caseTitle} desc={t.res.caseDesc} />
      <section className="py-12 rq-light">
        <motion.div {...inView} variants={container} className="rq-container grid gap-7 md:grid-cols-3">
          {items.map((c) => (
            <motion.div key={c.slug} variants={item} whileHover={{ y: -8 }}>
              <Link to={`/case-studies/${c.slug}`} className="rq-card overflow-hidden h-full group block" data-testid={`case-card-${c.slug}`}>
                <div className="h-48 overflow-hidden relative">
                  <img src={c.image} alt={c.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  <span className="absolute top-3 start-3 rounded-full bg-[rgba(4,20,15,0.8)] px-3 py-1 text-[11px] font-semibold text-[#7be0a8] backdrop-blur">{c.client}</span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-semibold text-white leading-snug">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[color:var(--rq-muted)] line-clamp-3">{c.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--rq-green)]">
                    {t.res.readMore}
                    <ArrowRight size={15} style={{ transform: flip }} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </section>
      <CTABand />
    </div>
  );
}
